<template>
	<DashboardPanel :title="`Welcome, ${ user.given_name }!`" :show-visibility-toggle="auth.pointOfContact != null" class="userpilot-mask w-full">
			<div v-if="auth.pointOfContact != null" class="flex flex-col mt-3">
				<p class="font-semibold text-grayscale-body">Point of contact: <span
					class="userpilot-mask font-normal">{{ auth.pointOfContact?.given_name }} {{ auth.pointOfContact?.family_name }}</span></p>
				<p class="userpilot-mask font-semibold text-grayscale-body">Email: <span class="clickable-text">{{ auth.pointOfContact?.email }}</span></p>
				<p class="userpilot-mask font-semibold text-ggrayscale-body">Phone: <span class="font-normal">{{ formattedPhone }}</span></p>
			</div>

		<div class="mt-3">
			<MaintenancePanel show-if-status="pending"/>
		</div>
	</DashboardPanel>
</template>

<script setup lang="js">

import DashboardPanel from '@/components/Dashboard/DashboardPanel.vue'
import { useAuthStore } from '@/stores/authStore.js'
import { computed, onBeforeMount } from 'vue'
import { Mask } from 'maska'
import MaintenancePanel from '@/components/Misc/MaintenancePanel.vue'

const auth = useAuthStore();
const user = auth.getAuth.user()

const formattedPhone = computed(() =>
{
	let phoneMask = new Mask({ mask: '(###) ###-####' })
	let phoneNumber = auth.pointOfContact?.phone_number
	return phoneNumber ? phoneMask.masked(phoneNumber) : ''
})

onBeforeMount(() => {
	//Needed otherwise the PoC doesn't show properly after switching
	auth.loadPointOfContact()
})

</script>